import { PDFManagerFactory } from 'pdftron';
import { DocumentType } from 'types';

export default function toggleSeparations(enable: boolean, documentType: DocumentType) {
  const viewer = PDFManagerFactory.getViewer(documentType);
  if (!viewer) return;

  const docViewer = viewer.instance.Core.documentViewer;
  const doc = docViewer.getDocument();

  if (enable) {
    doc.enableColorSeparations({ checkIfBaseColorsUsed: false });
  } else {
    doc.disableColorSeparations();
  }

  setTimeout(() => {
    docViewer.refreshAll();
    docViewer.updateView();
  }, 500);
}
